import { IGenericError } from '../common/defaults';
import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import * as ElasticActionTypes from './types';

export const getAllErrors = (url: string) => {
  return async (dispatch) => {
    try {
      await fetch(url)
        .then((res) => res.json())
        .then((result) => {
          dispatch(saveAllErrorsToStore(result));
        });
    } catch (ex) {
      console.log(ex);
    }
  };
};


export const saveAllErrorsToStore = (types: IGenericError[]) => {
  return {
    type: ElasticActionTypes.GET_ALL_ERRORS,
    value: types,
  };
};

export const getTestErrors = (url: string) => {
  return async (dispatch) => {
    try {
      await fetch(url)
        .then((res) => res.json())
        .then((result) => {
          dispatch(saveTestErrorsToStore(result));
        });
    } catch (ex) {
      console.log(ex);
    }
  };
};


export const saveTestErrorsToStore = (types: IGenericError[]) => {
  return {
    type: ElasticActionTypes.GET_TEST_ERRORS,
    value: types,
  };
};